export const customBreakpoints = { xs: 300, xs2: 400, sm: 800, md: 960, lg: 1280, xl: 1920 };
const scale = { xs: 1.12, sm: 1.12, md: 1.13, lg: 1.125 };
const baseSize = { xs: 0.7, xs2: 0.7, sm: 0.75, md: 0.9, lg: 1, xl: 1.1, biggest: 1.3 }; //xs,sm,md,lg,xl
// array below order is matter
const fontSizeKeys = [
    'caption', //0//18
    'body2', //1
    'body1', //2
    'subtitle2', //3
    'subtitle1', //4
    'h6', //5
    'h5', //6
    'h4', //7
    'h3', //8
    'h2', //9
    'h1' //10
];

export const createResponsiveFontSize = (index: number) => ({
    fontSize: `${baseSize.biggest * Math.pow(scale.lg, index - 2)}rem`,
    [`@media (max-width: ${customBreakpoints.xl}px)`]: {
        fontSize: `${baseSize.xl * Math.pow(scale.lg, index - 2)}rem`
    },
    [`@media (max-width: ${customBreakpoints.lg}px)`]: {
        fontSize: `${baseSize.lg * Math.pow(scale.lg, index - 2)}rem`
    },
    [`@media (max-width: ${customBreakpoints.md}px)`]: {
        fontSize: `${baseSize.md * Math.pow(scale.sm, index - 2)}rem`
    },
    [`@media (max-width: ${customBreakpoints.sm}px)`]: {
        fontSize: `${baseSize.sm * Math.pow(scale.sm, index - 2)}rem`
    },
    [`@media (max-width: ${customBreakpoints.xs2}px)`]: {
        fontSize: `${baseSize.xs2 * Math.pow(scale.xs, index - 2)}rem`
    },
    [`@media (max-width: ${customBreakpoints.xs}px)`]: {
        fontSize: `${baseSize.xs * Math.pow(scale.xs, index - 2)}rem`
    }
});

// because body1 is second element and base is calculated for body1 we subtract whole index from 2 (index==2 ==> to the power of 0 which is 1)
export const fontSizes = fontSizeKeys.reduce(
    (prev, cur, index) => ({
        ...prev,
        [cur]: createResponsiveFontSize(index)
    }),
    {}
);

const shadowColor = 'rgb(0, 0, 0,0.43)';

export const boxShadows = {
    regular: `0px 0px 7px 4px ${shadowColor}, 0 1px 2px rgba(0,0,0,0.24)`,
    higher: `0px 0px 4px 2px ${shadowColor}, 0 3px 5px rgba(0,0,0,0.24)`,

    bottom: `0 4px 2px -2px ${shadowColor}`
};

export const PORTRAIT_LARGE_MEDIA_QUERY = '@media (orientation: portrait) and (min-height:1000px)';
export const LANDSCAPE_SMALL_MEDIA_QUERY = '@media (orientation: landscape) and (max-height:650px)';
export const SMALL_DEVICE = '@media (max-height:650px), (max-width:800px)';
export const SMALL_OR_VERTICAL_DEVICE =
    '@media (max-width:650px),  (orientation: portrait) and (min-height:800px)';
export const SMALL_MOBILE_DEVICE = '@media (max-width:300px) ';
export const VERTICAL_DEVICE = '@media (max-aspect-ratio: 1/1)'
export const DESKTOP_MAX_WIDTH = 1296;
export const DESKTOP_MAX_HEIGHT = 700;

export const CSS_ANIM_CONFIG = '0.8s cubic-bezier(0.42, 0, 0.15, 1.4)';
export const CSS_LONG_ANIM_CONFIG = '2s cubic-bezier(0.42, 0, 0.15, 1.4)';
